import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Roles: [],
  Experience: '',
  jobType: [],
  basePay: '',
  companyName: '',
}

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    handleJobFilters: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value
      }
    },
    handleClearFilter: (state, action) => {
      return {
        ...state,
        [action?.payload?.key]: action.payload?.value,
        [action?.payload]: initialState[action?.payload]
      }
    }
  }
})

export const { handleJobFilters, handleClearFilter } = commonSlice.actions;

export default commonSlice.reducer;
